import { useState, useEffect } from "react";
import { useAuth } from "context/AuthContext";

export interface Organization_summary {
    id: number;
    latitude: string;
    location_name: string;
    longitude: string;
    max_spl: number;
    sensor_status: string;
    total_events: number;
    trigger_level: number;
}

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

export const useOrgSummary = () => {
    const [orgData, setOrgData] = useState<Organization_summary[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);
    const { sessionToken } = useAuth();

    useEffect(() => {
        if (!sessionToken) return;  // Prevents call if sessionToken is null

        const fetchOrgSummary = async () => {
            try {
                setIsLoading(true);
                const response = await fetch(`${API_BASE_URL}/db/organization`, {
                    headers: {
                        'Authorization': `Bearer ${sessionToken}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data: Organization_summary[] = await response.json();
                setOrgData(data);
            } catch (err) {
                setError(err instanceof Error ? err : new Error('An error occurred'));
            } finally {
                setIsLoading(false);
            }
        };

        fetchOrgSummary();
    }, [sessionToken]);  // Runs only when sessionToken changes

    return {
        orgData,
        isLoading,
        error,
        // Include the marker data as a computed property if still needed
        markers: orgData.map(loc => ({
            id: loc.id,
            name: loc.location_name,
            latLng: [parseFloat(loc.latitude), parseFloat(loc.longitude)] as [number, number]
        }))
    };
};
